import gql from 'graphql-tag';

import { getSingleProp } from 'src/lib/graphql';
import { executeGqlQuery } from 'src/graphql/client';

const QUERY = gql`
  query GetSurveyQuestions($requestId: ID!, $requestType: AiRequestTypeEnum!) {
    getSurveyQuestions(requestId: $requestId, requestType: $requestType) {
      surveyVersion
      questions {
        answerLength
        questionId
        questionText
        questionType
      }
    }
  }
`;

export function getSurveyQuestions(variables) {
  return executeGqlQuery({
    query: QUERY,
    variables,
  }).then(({ data }) => getSingleProp(data));
}
